import { render } from "./_index.vue?vue&type=template&id=afc9dfba"
import script from "./_index.vue?vue&type=script&lang=js"
export * from "./_index.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__